export type FilterConfigModalItem =
    | FilterConfigModalItemDefault
    | FilterConfigModalItemMultiple
    | FilterConfigModalItemColor
    | FilterConfigModalItemPrice
    | FilterConfigModalItemSimpleRange
    | FilterConfigModalItemSearchable;

interface FilterConfigModalItemBase {
    /** The key used for filtering data, usually matched to the same key on search service BE */
    filterKey: string;
    /** Optional label to display for the filter */
    label?: string;
}

export interface FilterConfigModalItemDefault
    extends FilterConfigModalItemBase {
    type: 'default';
}

export interface FilterConfigModalItemMultiple
    extends FilterConfigModalItemBase {
    type: 'multiple';
    columns: number;
}

export interface FilterConfigModalItemColor extends FilterConfigModalItemBase {
    type: 'color';
}

export interface FilterConfigModalItemPrice extends FilterConfigModalItemBase {
    type: 'price';
}

export interface FilterConfigModalItemSimpleRange
    extends FilterConfigModalItemBase {
    type: 'simpleRange';
    minPlaceholder: string;
    maxPlaceholder: string;
}

export interface FilterConfigModalItemSearchable
    extends FilterConfigModalItemBase {
    type: 'searchable';
    aggregationProperty: string;
    // aggregationProperty: keyof SearchServiceCompositeAggregationParams;
    searchInputPlaceholder: string;
    allowMultipleValues: boolean;
    allowAlphabeticalGrouping?: boolean;
    columns?: number;
}

export function isFilterConfigModalItemDefault(
    item: FilterConfigModalItem,
): item is FilterConfigModalItemDefault {
    return item.type === 'default';
}

export function isFilterConfigModalItemMultiple(
    item: FilterConfigModalItem,
): item is FilterConfigModalItemMultiple {
    return item.type === 'multiple';
}

export function isFilterConfigModalItemColor(
    item: FilterConfigModalItem,
): item is FilterConfigModalItemColor {
    return item.type === 'color';
}

export function isFilterConfigModalItemPrice(
    item: FilterConfigModalItem,
): item is FilterConfigModalItemPrice {
    return item.type === 'price';
}

export function isFilterConfigModalItemSimpleRange(
    item: FilterConfigModalItem,
): item is FilterConfigModalItemSimpleRange {
    return item.type === 'simpleRange';
}

export function isFilterConfigModalItemSearchable(
    item: FilterConfigModalItem,
): item is FilterConfigModalItemSearchable {
    return item.type === 'searchable';
}
